import React from "react"
import Navbar from "./Navbar/Navbar"
import Footer from "./Footer"

export default function SiteContainer({ children }) {
  return (
    <div>
      <Navbar />
      {children}
      <Footer />
    </div>
  )
}
